import brandJoin from '@/view/brand/join'

const brandRouter = [
  {
    path: '/brand/join.html',
    name: 'brand-join',
    component: brandJoin,
    meta: {
      title: '解决方案馆供应商招募'
    }
  }
]

export default brandRouter



// WEBPACK FOOTER //
// ./src/router/brand/brand.js